import { useState } from 'react'
import { AccountsToolbar } from './AccountsToolbar'
import { AccountsTable } from './AccountsTable'
import { useAccounts, ACCOUNTS_PAGE_SIZE } from './useAccounts'
import { Pagination } from '../shared/Pagination'

/**
 * Top-level Accounts island. Replaces the legacy panel-accounts content
 * (toolbar + table + pagination). The Add/Edit modal and the account
 * drawer remain legacy for PR #1.
 */
export default function AccountsIsland() {
  const [search, setSearch] = useState('')
  const [industry, setIndustry] = useState('')
  const [page, setPage] = useState(1)

  const { rows, total, status, error } = useAccounts({ search, industry, page })

  const handleSearchChange = (value: string) => {
    setSearch(value)
    setPage(1)
  }
  const handleIndustryChange = (value: string) => {
    setIndustry(value)
    setPage(1)
  }

  return (
    <>
      <AccountsToolbar
        search={search}
        industry={industry}
        onSearchChange={handleSearchChange}
        onIndustryChange={handleIndustryChange}
      />
      <AccountsTable
        rows={rows}
        status={status}
        error={error}
        hasFilter={search.trim() !== '' || industry !== ''}
      />
      <Pagination total={total} page={page} pageSize={ACCOUNTS_PAGE_SIZE} onPageChange={setPage} />
    </>
  )
}
